import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { IoIosArrowBack, IoMdShare } from "react-icons/io";
import ScrollTop from "../components/ScrollTop";
import PopupMenu from "../components/PopupMenu";
import { useSelector } from "react-redux";
import CustomerCalendar from "../components/CustomerCalendar";
import Loader from "../components/Loader";
const DoctorDetails = () => {
  const doctors = useSelector((state) => state.home.doctors);
  const { id } = useParams(); // Get the id from the URL
  const navigate = useNavigate();
  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    if (doctors.length > 0) {
      const foundDoctor = doctors.find((g) => g._id.toString() === id);
      if (foundDoctor) {
        setDoctor(foundDoctor);
        setLoading(false);
      } else {
        console.log(`No Doctor found for id: ${id}`);
        setLoading(false);
      }
    } else {
      // Simulate loader and redirect if no data is found
      const timer = setTimeout(() => {
        navigate("/doctors");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [doctors, id, navigate]);

  // Show loader for 2 seconds if data isn't available
  if (loading) {
    return <Loader />;
  }

  if (!doctor) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-lg font-semibold text-red-500">Doctor not found!</p>
      </div>
    );
  }

  const handleShare = () => {
    const doctorLink = `${window.location.origin}/doctor/${doctor._id}`;
    navigator.clipboard
      .writeText(doctorLink)
      .then(() => {
        toast.success("Lien copié avec succès - تم نسخ الرابط بنجاح");
      })
      .catch(() => {
        toast.error("Failed to copy link");
      });
  };

  return (
    <section
      className="bg-cover bg-no-repeat relative bg-left"
      style={{
        backgroundImage: `url(${doctor.image})`,
      }}
    >
      <div
        className="left-0 top-0 w-full pt-10 pb-10 h-full bg-[#2422228a]"
        style={{ backdropFilter: "blur(8px)" }}
      >
        <div
          className="w-[85%] sm:w-[99%] mx-auto mt-10 p-10 md:p-2 bg-slate-300 rounded-2xl"
          style={{ backdropFilter: "blur(8px)" }}
        >
          {/* Navigation Bar */}
          <div className="flex justify-between items-center mb-4 md:mt-3">
            <button className="round-btn" onClick={() => navigate(-1)}>
              <IoIosArrowBack />
            </button>
            <button className="round-btn" onClick={handleShare}>
              <IoMdShare />
            </button>
          </div>

          {/* Doctor Content */}
          <div className="flex lg:block sm:px-1 px-10 pb-5 justify-center align-middle items-center">
            <img
              className="w-[400px] h-[400px] sm:w-[200px] sm:h-[200px] object-cover object-center rounded-full"
              src={doctor.image}
              alt={doctor.name}
            />
            <div className="px-5 lg:pt-5">
              <h1 className="text-4xl font-bold mb-1">{doctor.name}</h1>
              <p className="text-[12px] font-semibold text-[#2b3e43] mt-1 px-3 rounded-xl">
                Depuis {new Date(doctor.createdAt).toLocaleDateString()}
              </p>
              <h3 className="text-[#5b2c68] text-[16px] font-semibold">
                Région d'activité: {doctor.businessInfo?.country},{" "}
                {doctor.businessInfo?.wilaya}{" "}
              </h3>

              <Link to={`/dashboard/chat/${doctor._id}`}>
                <button className="main-btn1 mt-4">Contactez-moi</button>
              </Link>
              <div className="block">
                <p className="mt-6 text-lg text-slate-600">
                  {doctor.businessInfo?.description}
                </p>
              </div>
            </div>
          </div>
          <hr />
          <CustomerCalendar doctor={doctor} />
        </div>
      </div>
      <ScrollTop />
      <PopupMenu />
    </section>
  );
};

export default DoctorDetails;
